<template>
  <div class="videoModal">
    <!-- VIDEO MODAL -->
    <div
      class="modal fade youtube-video"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            id="close-video"
            type="button"
            class="button btn btn-default text-right"
            data-dismiss="modal"
          >
            <i class="icofont-close-line-circled"></i>
          </button>
          <div class="modal-body">
            <div id="video-container" class="video-container">
              <iframe
                id="youtubevideo"
                src="#"
                width="640"
                height="360"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoBox",
};
</script>
